export default {
  "foot": {
    "title": "Century Gamesのプレイヤー様",
    "p1": "IDを入力し、支払いを進めてください。  支払い金額は直接お客様の関連アカウントに更新されます。表示されない場合は、ゲームを再読み込みするか、カスタマーサポートまでお問い合わせください。",
    "p2": "ご不明な点がございましたら、お気軽にカスタマーサポートまでお問い合わせください。今後ともよろしくお願いいたします！",
    "copyright": "© Copyright 2024 Century Games.",
    "service": "ご利用規約",
    "policy": "プライバシーポリシー",
    "descriptionTitle": "どのように機能していますか？"
  },
  "accept": {
    "title": "このウェブサイトでは、より快適に閲覧していただくためにクッキーを使用しています。当社の<a href=\"https://www.centurygames.com/ja/privacy-policy/\" style=\"color: #58a8a5;\"> プライバシーポリシー</a>をご覧ください。本サイトの利用を継続することにより、お客様は、当社がお客様のデバイスにクッキーを保存し、アクセスすることに同意したものとみなされます。",
    "decline": "拒否する",
    "accept": "同意する"
  },
  "game": {
    "inapptext": "またはゲームにログインする",
    "loginfail": "ログイン失敗",
    "logintip": "ゲームの承認に失敗した場合は、ゲームを最新バージョンに更新するか、別のブラウザで再試行してください。",
    "reloadmsg": "ログイン結果を表示するには、「再読み込み」ボタンをタップしてください。",
    "reload": "再読み込み",
    "appnotice": "ゲームアプリからログインする場合は、外部ブラウザでストアを開いてください。",
    "changeaccount": "本当にログアウトしますか？",
    "login": "ログイン",
    "notice": "お知らせ",
    "confirm": "確認",
    "loginuserid": "ユーザーID",
    "palceholder": "ユーザーIDを入力してください",
    "okbtn": "OK",
    "loginbtn": "ゲームからログイン",
    "changebtn": "またはユーザーIDでログイン",
    "useTitle": "アカウント",
    "checkBtn": "確認",
    "findid": "ユーザーIDが見つかりませんか？",
    "checktext": "通常は設定に表示されます。はてなマーク（？）をタップしてください。",
    "username": "ニックネーム：",
    "userId": "ユーザーID：",
    "packageTitle": "チャージ金額",
    "edit": "編集",
    "paymentTitle": "支払い方法",
    "total": "合計",
    "goPay": "支払う",
    "noSelectPackageTips": "金額が選択されていません",
    "payFail": "決済に失敗しました",
    "camelPayfail": "決済に失敗しました",
    "payFailTips1": "Adyenカスタマーサポートに連絡する",
    "payFailTips2": "PayPalカスタマーサポートに連絡する",
    "paySuccess": "支払い成功",
    "paySuccessTips2": "購入した商品が届かない場合、カスタマーサポートに連絡する前に、まずゲームを再読み込みしてください！",
    "camelPaySuccess": "支払い成功",
    "transactionId": "取引 ID",
    "paySuccessTips": "商品のお届けに時間がかかる場合があります。",
    "deliveryFail": "商品発送に失敗しました",
    "deliveryFailTips": "カスタマーサポートにご連絡ください。",
    "orderTitle": "ご注文内容",
    "paidWith": "お支払い方法",
    "orderID": "取引 ID",
    "payStatus": "お支払い状況",
    "orderTotal": "合計金額",
    "transactionDate": "取引日",
    "goOnPay": "再度購入",
    "getInvoice": "領収書",
    "camelDeliveryFail": "商品発送に失敗しました",
    "confirmOrder": "ご注文の確認",
    "confirmFollow": "以下の情報をご確認ください：",
    "nickname": "ニックネーム：",
    "packageName": "商品名",
    "totalPayment": "合計金額",
    "confirmPayWith": "お支払い方法",
    "confirmAndGoOn": "確認＆決済を進める",
    "orderCancel": "キャンセル",
    "getInvoiceTitle": "メールで送信",
    "getInvoiceTips": "領収書をメールでお受け取りになりたい場合は、メールアドレスをご入力ください。",
    "getInvoiceTips1": "領収書を受け取るにはメールアドレスを入力してください",
    "getInvoiceTips2": "メールアドレスの収集と保存に同意する。",
    "getInvoiceTips3": "割引、プロモーションなどのマーケティングメール受信に同意する",
    "invoiceSend": "送信",
    "sendSuccess": "領収書のメール送信に成功しました",
    "id404": "ユーザーIDがが存在しません",
    "packageLoadingText": "ショップアイテム更新中...",
    "taxTips": "税込価格",
    "adyenTips": "この決済サービスは、オランダ中央銀行の監督下にあり、銀行免許の下で運営されているAdyenによって提供されています。認証に関するお問い合わせは、<a href=\"https://www.adyen.com/platform/certifications\">https://www.adyen.com/platform/certifications</a> をご覧ください。Adyenがどのようにお客様のデータを保護しているかについては、<a href=\"https://www.adyen.com/policies-and-disclaimer/privacy-policy\">https://www.adyen.com/policies-and-disclaimer/privacy-policy</a> をご覧ください。",
    "paypalTips": "決済サービスはPayPalによって提供されます。PayPalがどのようにお客様のデータを保護しているかについては、<a href=\"https://www.paypal.com/c2/webapps/mpp/ua/privacy-full\">https://www.paypal.com/c2/webapps/mpp/ua/privacy-full</a> をご参照ください。",
    "switchCountryTips": "ご希望の国/地域は${servercountry}と指定されています。国と通貨を変更しますか？",
    "paypalBtn": "カードでお支払い",
    "paypalOr": "または",
    "paypalCard1": "カード所有者の氏名（任意）",
    "paypalCard2": "カード番号",
    "checkUserID": "連携",
    "success": "成功",
    "changeCurrencyContent": "地域と通貨をゲーム内の設定に合わせますか： ${servercountry}?",
    "productDescription": "ファームバックスは、現金と同等にゲーム内のパックやお得なセットを購入する際に使用できる通貨単位です。",
    "payButton": "支払う",
    "userIdNotice": "まずユーザーIDを入力して、ゲームアカウントを連携してください。",
    "account": "アカウント",
    "card": "カード",
    "notification": "ユーザーIDを入力してアカウントをリンクし、ご希望のアイテムを選択した後、ご希望のお支払い方法でお支払いください。ゲームを再読み込みすると、購入したアイテムがアカウントに表示され、使用できるようになります。\n\nご不明な点がございましたら、ゲーム内のカスタマーサポートまでお気軽にお問い合わせください。",
    "rongluRank": "炉のレベル：",
    "tips": "使い方？",
    "checkTIps1": "<a :href=\"policyUrl\">「プライバシーポリシー」</a>、 <a :href=\"serviceURl\">「利用規約」</a> および <a :href=\"paymentURl\">「決済利用規約」</a>をすべて理解し、同意します。",
    "checkTIps2": "お読みいただき、同意してください",
    "selectTips": "(最新のゲーム内購入の通貨が選択されます)",
    "koPayTips": "ご利用の銀行カードが韓国ウォンを外貨として使用している場合、自国通貨支払いサービス（DCC）が適用され、本サイトではなく第三者機関により追加の取扱手数料が請求される場合があります。",
    "PayTips": ""
  },
  "invoice": {
    "title": "領収書",
    "transactionId": "取引 ID",
    "transactionDate": "取引日",
    "totalAmount": "合計金額",
    "paymentMethod": "お支払い方法",
    "description": "詳細情報",
    "game": "ゲーム",
    "quantity": "数量",
    "price": "価格",
    "amount": "金額",
    "total": "合計金額",
    "footTitle": "備考",
    "footContent": "Century Gamesをご利用いただきありがとうございます！",
    "button1": "領収書を受け取る",
    "button2": "領収書なしで戻る",
    "giveupInvoice": "ご注文の領収書は発行されません。よろしいですか？"
  },
  "payment": {
    "card": "クレジットカード/デビットカード",
    "paypal": "PayPal"
  },
  "country": {
    "countryTitle1": "国/地域",
    "Africa": "アフリカ",
    "America": "アメリカ",
    "Asia": "アジア",
    "Europe": "ヨーロッパ",
    "Oceania": "オセアニア",
    "ZA": "南アフリカ",
    "US": "アメリカ",
    "HK": "香港、中国",
    "JP": "日本",
    "KR": "韓国",
    "SG": "シンガポール",
    "SA": "サウジアラビア",
    "IQ": "イラク",
    "TW": "台湾、中国",
    "TH": "タイ",
    "GB": "イギリス",
    "AU": "オーストラリア",
    "countryLanguage1": "言語",
    "AE": "アラブ首長国連邦",
    "DE": "ドイツ",
    "PT": "ポルトガル",
    "RU": "ロシア",
    "ES": "スペイン",
    "CH": "スイス",
    "TR": "トルコ",
    "KW": "クウェート",
    "QA": "カタール",
    "PL": "ポーランド",
    "ID": "インドネシア",
    "IT": "イタリア",
    "IN": "インド",
    "FR": "フランス",
    "CA": "カナダ",
    "NL": "オランダ",
    "AT": "オーストリア",
    "RS": "セルビア",
    "SE": "スウェーデン",
    "MY": "マレーシア",
    "BE": "ベルギー",
    "DK": "デンマーク",
    "FI": "フィンランド",
    "PH": "フィリピン",
    "NO": "ノルウェー",
    "BR": "ブラジル",
    "NZ": "ニュージーランド",
    "UA": "ウクライナ",
    "RO": "ルーマニア"
  },
  "extra_info": {
    "kingdom": "所在王国："
  },
  "adyen": {
    "note": "決済サービスは、Adyenが提供しており、国際的なクレジットカード会社による最高レベルのPCI-DSS認証を取得し、国内および海外のカード決済をサポートしています。",
    "note2": "注意：「次回のお支払いのため詳細を保存」をチェックすると、現在のブラウザに決済カード情報が保存され、後で簡単に決済を行うことができます。"
  },
  "pay": {
    "error1": "何か問題が発生した場合は、後ほど再試行するか、別の決済方法をご利用ください。ご不明な点がございましたら、カスタマーサポートまでお問い合わせください。"
  },
  "meta": {
    "title": "ファミリーファームの冒険ショップ",
    "description": "ファミリーファームの冒険ショップは、ファミリーファームの冒険の公式ショップであり、プレイヤー向けの割引チャージとゲーム内パックを提供しています。",
    "keywords": "牧場、栽培、市場、アップグレード、探査、マップ、キャラクター、レベル、シミュレーション、戦略、支払い、ストア、チャージ、支払い"
  }
};


// WEBPACK FOOTER //
// ./src/lang/JA.js